module.exports = __webpack_public_path__ + "static/media/baby.5c3cf8e8.glb";